<!-- Header -->
<div class="flex items-center gap-3 p-4">
  <!-- Identity -->
  <div class="flex flex-1 min-w-0 items-center gap-2 flex-wrap">
    <span class="font-semibold truncate">{{ server().name }}</span>
    <span
      class="text-xs bg-[var(--p-surface-200)] text-surface-500 rounded-full py-0.5 px-2.5 tabular-nums leading-none">
      {{ server().customerProductCount }}
    </span>
  </div>

  <!-- Actions -->
  <div class="flex items-center gap-1 shrink-0">
    <elcia-button
      (onClick)="generateCredentials()"
      [icon]="'lock'"
      [isLoading]="isGeneratingCredentials()"
      [severity]="'secondary'"
      [tooltip]="'licence-server.generate-credentials' | translate"
      [variant]="'text'"/>
    <elcia-button (onClick)="edit()" [icon]="'edit'" [severity]="'secondary'" [variant]="'text'"/>
    <elcia-button (onClick)="delete()" [icon]="'delete'" [severity]="'danger'" [variant]="'text'"/>
  </div>
</div>

<!-- Assigned products -->
<div class="flex flex-col gap-4 px-4 pb-4 pt-1 border-t border-primary-50">
  @if (!hasProducts()) {
    <div class="py-4 text-sm text-surface-400 text-center">
      {{ 'licence-server.no-products' | translate }}
    </div>
  } @else {
    <!-- Licences -->
    @if (licences().length > 0) {
      <div class="flex flex-col gap-2">
        <span
          class="text-xs uppercase tracking-wide text-surface-400">{{ 'licence-server.licences' | translate }}</span>
        @for (licence of licences(); track licence.id) {
          <div class="flex flex-col gap-1 p-3 rounded-xl border border-primary-50 bg-[var(--p-surface-50)]">
            <div class="flex items-center gap-2 flex-wrap">
              <span class="font-medium truncate">{{ licence.name }}</span>
              @if (!licence.isActive) {
                <span
                  class="text-xs bg-[var(--p-surface-200)] text-surface-500 rounded-full py-0.5 px-2.5 leading-none">
                  {{ 'licence-server.inactive' | translate }}
                </span>
              }
            </div>
            <!-- Reference = customer-product description -->
            @if (licence.reference) {
              <span class="text-xs text-surface-400">{{ licence.reference }}</span>
            }
            <!-- Features of the licence (collapsible, closed by default) -->
            @if (licence.features.length > 0) {
              <button
                type="button"
                class="flex items-center gap-1 mt-1 text-xs text-surface-400 hover:text-surface-500 w-fit cursor-pointer"
                (click)="toggleFeatures(licence.id)">
                <elcia-icon [iconType]="isFeaturesExpanded(licence.id) ? 'chevron-down' : 'chevron-right'"
                            iconSize="xs"/>
                <span>{{ 'licence-server.features' | translate }} ({{ licence.features.length }})</span>
              </button>
              @if (isFeaturesExpanded(licence.id)) {
                <div class="flex flex-col gap-0.5 mt-1 pl-3 border-l-2 border-primary-50">
                  @for (feature of licence.features; track $index) {
                    <span class="text-xs text-surface-400 truncate">{{ feature }}</span>
                  }
                </div>
              }
            }
          </div>
        }
      </div>
    }

    <!-- Plugins -->
    @if (plugins().length > 0) {
      <div class="flex flex-col gap-2">
        <span class="text-xs uppercase tracking-wide text-surface-400">{{ 'licence-server.plugins' | translate }}</span>
        @for (plugin of plugins(); track plugin.id) {
          <div
            class="flex items-center gap-2 flex-wrap p-3 rounded-xl border border-primary-50 bg-[var(--p-surface-50)]">
            <span class="font-medium truncate">{{ plugin.name }}</span>
            @if (!plugin.isActive) {
              <span class="text-xs bg-[var(--p-surface-200)] text-surface-500 rounded-full py-0.5 px-2.5 leading-none">
                {{ 'licence-server.inactive' | translate }}
              </span>
            }
          </div>
        }
      </div>
    }
  }
</div>
